import { Link } from "react-router-dom";
import { Photo } from "@/components/shared/Photo";

const CTAFinal = () => (
  <section className="mx-auto max-w-[1180px] px-8 pb-[90px] max-[900px]:px-5">
    <div className="relative isolate overflow-hidden rounded-3xl bg-primary px-11 py-14 text-center text-primary-foreground max-[900px]:px-6 max-[900px]:py-10">
      <div className="absolute inset-0 -z-10">
        <Photo id="equipe-balcao" decorative sizes="(max-width: 900px) 100vw, 1120px" />
        <div className="absolute inset-0 bg-primary/[0.88]" />
      </div>
      <h2 className="mx-auto max-w-[640px] text-4xl font-bold leading-tight tracking-[-0.03em] max-[900px]:text-[28px]">
        Me conte o que trava no seu negócio
      </h2>
      <p className="mx-auto mt-4 max-w-[520px] text-base leading-[1.6]">
        Site, sistema ou automação: em 30 minutos, sem apresentação comercial, eu digo o que vale
        fazer primeiro — mesmo que você não feche nada.
      </p>
      <Link
        to="/contato"
        className="mt-7 inline-flex h-[52px] items-center rounded-full bg-white px-[30px] text-[15px] font-bold text-primary-deep transition hover:brightness-[.94]"
      >
        Agendar diagnóstico gratuito
      </Link>
    </div>
  </section>
);

export default CTAFinal;
